module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.7500519d.woff";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/fonts/roboto/Roboto-Thin.woff
// module id = 1457
// module chunks = 0